import { Consultation } from './Consultation/Consultation'
import { Contact } from './Contact/Contact'
import { Help } from './Help/Help'
import { Hero } from './Hero/Hero'
import { Hiring } from './Hiring/Hiring'
import { Plans } from './Plans/Plans'
import { Simulation } from './Simulation/Simulation'
import { Solutions } from './Solutions/Solutions'

export {
  Consultation,
  Contact,
  Help,
  Hero,
  Hiring,
  Plans,
  Simulation,
  Solutions
}
